import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bbd9588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-page" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "group-page__title" }, "Очереди", -1))
const _hoisted_4 = { class: "group-page__list" }
const _hoisted_5 = {
  key: 1,
  class: "group-page__empty"
}

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { DeleteQueueInfoModel, QueueModel, UpdateQueueNameModel } from './models';
import { AdapterService } from './adapter';
import { FormCreateQueue, QueueCard, QueueCardtemModel } from '@/components';
import { pending } from './utils';
import { TirPmSystemMessage } from 'tir-pm-system-message';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmIconView,
  TirPmPopover,
  PopoverPositionEnum,
} from 'tir-components';
import { FolderOpenIcon } from 'tir-style-system/icons/outline';
import { QueueTasksModel } from '@/components/sidebar/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'group-page',
  props: {
  /**ID группы */
  groupId: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const adapter = new AdapterService();



// Обновление очереди
const onUpdateQueue = (_queue: QueueTasksModel | UpdateQueueNameModel) => {
  const currentQueue = queues.value.find(
    (queue) => queue.Id == (_queue as UpdateQueueNameModel).QueueId,
  );
  currentQueue.Name = _queue.Name;
};

/**Загрузка */
const isLoading = ref(false);
/**Список очередей */
const queues = ref(new Array<QueueModel>());

/**Список очередей в виде карточек */
const queuesCards = computed(() =>
  queues.value.map(
    (queue) =>
      new QueueCardtemModel({
        Id: queue.Id,
        Name: queue.Name,
        TasksCount: queue.TasksCount,
        ParentGroupId: props.groupId,
      }),
  ),
);

const pendingGetQueueList = pending(async (groupId: number) => {
  const resp = await adapter.getQueueList(groupId);
  if (resp.IsSuccess) queues.value = resp.Value;
});
/**Подписаться/отписаться на/от события */
const toggleEvents = (isSubscribe: boolean) => {
  const eventFnName = isSubscribe ? 'on' : 'removeListener';

  adapter.OnUpdateQueueName[eventFnName](onUpdateQueue);
  adapter.DeleteQueueEvent[eventFnName](onDeleteQueue);
  adapter.CreateQueueEvent[eventFnName](onCreateQueue);
};

const getQueueList = async () => {
  isLoading.value = true;
  await pendingGetQueueList(props.groupId);
  isLoading.value = false;
};

watch(
  () => props.groupId,
  () => {
    getQueueList();
  },
);

/**При создании очереди из сайдбара */
const onCreateQueueFromSidebar = (e: any) => {
  const groupId = e?.detail?.GroupId as number | undefined;
  if (!groupId || groupId !== props.groupId) return;
  getQueueList();
};
/**При удалении очереди из сайдбара */
const onDeleteQueue = (queue: DeleteQueueInfoModel | string) => {
  const queueId = (queue as DeleteQueueInfoModel).QueueId;
  if (!queueId || !queues.value.some((queue) => queue.Id === queueId)) return;
  queues.value = queues.value.filter((queue) => queue.Id !== queueId);
};
/**При создании "Очереди" */
const onCreateQueue = (queue: QueueTasksModel) => {
  getQueueList();
};
/**После вмонтирования компонента */
onMounted(() => {
  getQueueList();
  toggleEvents(true);
});
/**После размонтирования компонента */
onUnmounted(() => {
  toggleEvents(false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (queuesCards.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(queuesCards.value, (queue) => {
                    return (_openBlock(), _createBlock(_unref(QueueCard), {
                      key: queue.Id,
                      queue: queue
                    }, null, 8, ["queue"]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(TirPmSystemMessage), null, {
                  topDescImage: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(TirPmIconView), { style: {"width":"5rem","height":"5rem"} }, {
                        mainSlot: _withCtx(() => [
                          _createVNode(_unref(FolderOpenIcon), { style: {"width":"3.5rem","height":"3.5rem","color":"var(--neutral-70, #686c73)"} })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  mainTitleSlot: _withCtx(() => [
                    _createTextVNode("В данной папке еще нет очередей")
                  ]),
                  mainSubtitleSlot: _withCtx(() => [
                    _createTextVNode("Создайте очередь, чтобы добавить задачи")
                  ]),
                  descriptionSlot: _withCtx(() => [
                    _createTextVNode("Задачи могут содержаться только в очередях")
                  ]),
                  actionsSlot: _withCtx(() => [
                    _createVNode(_unref(TirPmPopover), {
                      width: "26.25rem",
                      class: "group-page__empty-popover",
                      position: _unref(PopoverPositionEnum).Bottom
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TirPmButton), {
                          class: "group-page__empty-button",
                          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                          size: _unref(TirPmButtonSizeEnum).Regular
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Создать очередь ")
                          ]),
                          _: 1
                        }, 8, ["variant", "size"])
                      ]),
                      content: _withCtx(() => [
                        _createVNode(_unref(FormCreateQueue), {
                          groupId: __props.groupId,
                          onOnCreate: onCreateQueue
                        }, null, 8, ["groupId"])
                      ]),
                      _: 1
                    }, 8, ["position"])
                  ]),
                  _: 1
                })
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})